import { render, staticRenderFns } from "./DispatchPageForDriver.vue?vue&type=template&id=27cea3e6&scoped=true"
import script from "./DispatchPageForDriver.vue?vue&type=script&lang=js"
export * from "./DispatchPageForDriver.vue?vue&type=script&lang=js"
import style0 from "./DispatchPageForDriver.vue?vue&type=style&index=0&id=27cea3e6&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "27cea3e6",
  null
  
)

export default component.exports